import { Component, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
    selector: 'dbm-timeframe',
    template: require('./dbm-timeframe.component.html'),
    styles: [require('./dbm-timeframe.component.scss')]
})
export class DbmTimeframeComponent implements OnInit {

    @Output() public onSelected = new EventEmitter<any>();

    public times: any[];
    public _selectedTime: any;

    constructor() {
        const getToday = () => new Date();
        const getTodayBegin = () => new Date().setHours(0, 0, 0, 0);
        const getEndOfToday = () => getToday().setHours(23, 59, 59, 999);

        const getYesterday = () => new Date(new Date().setDate(new Date().getDate() - 1));

        const days30ago = new Date(getToday().setDate(getToday().getDate() - 30));
        const days7ago = getToday().setDate(getToday().getDate() - 7);
        this.times = [
            { name: 'Today', value: { fromDate: getTodayBegin(), toDate: getEndOfToday() } },
            { name: 'Yesterday', value: { fromDate: getYesterday().setHours(0, 0, 0, 0), toDate: getYesterday().setHours(23, 59, 59, 999) } },
            { name: 'Last 7 Days', value: { fromDate: days7ago, toDate: getEndOfToday() } },
            { name: 'Last 30 Days', value: { fromDate: days30ago, toDate: getEndOfToday() } },
            { name: 'Custom', value: { fromDate: days30ago, toDate: getEndOfToday() } }
        ];
    }

    public set selectedTime(value: any) {
        this._selectedTime = value;
        this.onSelected.emit(value);
    }

    public get selectedTime() {
        return this._selectedTime;
    }

    public ngOnInit() {
        this.selectedTime = this.times[3];
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dbm-components/dbm-timeframe/dbm-timeframe.component.ts